<template>
  <div class="proveedores-page">
    <!-- Header -->
    <div class="prov-header">
      <div>
        <span class="header-eyebrow">Gestion</span>
        <h2 class="header-title">Proveedores</h2>
      </div>
      <div class="header-actions">
        <button class="btn-prov btn-prov--primary" @click="toggleFormulario">
          <i :class="showForm ? 'fa-solid fa-xmark' : 'fa-solid fa-plus'"></i>
          {{ showForm ? 'Cerrar' : 'Nuevo proveedor' }}
        </button>
      </div>
    </div>

    <!-- KPI Strip -->
    <div class="kpi-strip">
      <div class="kpi-card">
        <span class="kpi-label">Total</span>
        <span class="kpi-value">{{ listProveedores.length }}</span>
        <span class="kpi-foot">proveedores</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Harber London</span>
        <span class="kpi-value">{{ countHarber }}</span>
        <span class="kpi-foot">proveedores</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Craft Lab</span>
        <span class="kpi-value">{{ countCraft }}</span>
        <span class="kpi-foot">proveedores</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Paises</span>
        <span class="kpi-value">{{ countPaises }}</span>
        <span class="kpi-foot">distintos</span>
      </div>
    </div>

    <!-- Formulario crear/editar -->
    <transition name="slide">
      <div class="form-card" v-if="showForm">
        <div class="form-card__header">
          <div class="form-card__icon" :class="proveedorSelected ? 'form-card__icon--warning' : 'form-card__icon--primary'">
            <i :class="proveedorSelected ? 'fa-solid fa-pen' : 'fa-solid fa-plus'"></i>
          </div>
          <div>
            <h3 class="form-card__title">{{ proveedorSelected ? 'Editar proveedor' : 'Nuevo proveedor' }}</h3>
            <p class="form-card__subtitle" v-if="proveedorSelected">Editando: {{ proveedorSelected.nombre }}</p>
          </div>
        </div>

        <div class="form-grid">
          <div class="field field--span2">
            <label class="field__label">Nombre</label>
            <b-form-input size="sm" placeholder="Nombre del proveedor" v-model="nombre" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Nickname</label>
            <b-form-input size="sm" placeholder="Alias corto" v-model="nickname" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Contacto</label>
            <b-form-input size="sm" placeholder="Persona de contacto" v-model="contacto" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Email</label>
            <b-form-input size="sm" placeholder="email@proveedor.com" v-model="email" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Telefono</label>
            <b-form-input size="sm" placeholder="+34..." v-model="telefono" class="field__input" />
          </div>
          <div class="field field--span2">
            <label class="field__label">Direccion</label>
            <b-form-input size="sm" placeholder="Direccion completa" v-model="direccion" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Pais</label>
            <b-form-input size="sm" placeholder="Pais" v-model="pais" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">CIF / NIF</label>
            <b-form-input size="sm" placeholder="B12345678" v-model="cif" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Empresa</label>
            <v-select v-model="empresa" :options="['Harber London', 'Craft Lab']" class="select-styled" />
          </div>
          <div class="field">
            <label class="field__label">Plazo pago</label>
            <b-form-input size="sm" placeholder="Dias" v-model="inputPlazo" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">
              Color
              <span :class="'badge-color badge-color--' + colorSelect"></span>
            </label>
            <v-select v-model="colorSelect" :options="['primary', 'secondary', 'success', 'danger', 'warning', 'info']" class="select-styled" />
          </div>
          <div class="field field--span2">
            <label class="field__label">Web</label>
            <b-form-input size="sm" placeholder="https://..." v-model="web" class="field__input" />
          </div>
        </div>

        <div class="form-card__footer">
          <button v-if="proveedorSelected" class="btn-prov btn-prov--ghost" @click="limpiarFormulario()">
            Cancelar
          </button>
          <button
            class="btn-prov"
            :class="proveedorSelected ? 'btn-prov--warning' : 'btn-prov--primary'"
            @click="guardarProveedor()"
          >
            <i :class="proveedorSelected ? 'fa-solid fa-check' : 'fa-solid fa-plus'"></i>
            {{ proveedorSelected ? 'Actualizar' : 'Crear proveedor' }}
          </button>
        </div>
      </div>
    </transition>

    <!-- Listado -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Listado</h3>
        <div class="list-card__filters">
          <div class="filter-pills">
            <button
              class="pill"
              :class="{ active: proveedorSelect === 'Todos' }"
              @click="proveedorSelect = 'Todos'"
            >Todos</button>
            <button
              class="pill"
              :class="{ active: proveedorSelect === 'Harber London' }"
              @click="proveedorSelect = 'Harber London'"
            >Harber London</button>
            <button
              class="pill"
              :class="{ active: proveedorSelect === 'Craft Lab' }"
              @click="proveedorSelect = 'Craft Lab'"
            >Craft Lab</button>
          </div>
          <div class="search-box">
            <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
            <input
              type="text"
              class="search-box__input"
              placeholder="Buscar proveedor..."
              v-model="buscar"
            />
          </div>
        </div>
      </div>

      <div class="table-wrapper">
        <b-table
          :items="linesTable"
          :fields="columnasTable"
          class="mb-0"
          hover
          responsive
          show-empty
          empty-text="No se encontraron proveedores"
          sort-icon-left
          thead-class="table-head"
          tbody-tr-class="table-row"
        >
          <template #cell(nombre)="data">
            <div class="cell-nombre">
              <span class="cell-nombre__dot" :style="{ background: getColor(data.item.color) }"></span>
              <div>
                <span class="cell-nombre__name">{{ data.item.nombre }}</span>
                <span class="cell-nombre__nick" v-if="data.item.nickname">{{ data.item.nickname }}</span>
              </div>
            </div>
          </template>

          <template #cell(email)="data">
            <span class="cell-mono">{{ data.item.email }}</span>
          </template>

          <template #cell(pais)="data">
            <span class="cell-pais" v-if="data.item.pais">{{ data.item.pais }}</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(empresa)="data">
            <span class="badge-empresa" :class="data.item.empresa === 'Harber London' ? 'badge-empresa--hb' : 'badge-empresa--cl'">
              {{ data.item.empresa === 'Harber London' ? 'HB' : 'CL' }}
            </span>
          </template>

          <template #cell(cif)="data">
            <span class="cell-mono" v-if="data.item.cif">{{ data.item.cif }}</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(acciones)="data">
            <div class="cell-actions">
              <button class="action-btn action-btn--view" @click="verInformacion(data.item)" title="Ver detalle">
                <i class="fa-solid fa-eye"></i>
              </button>
              <button class="action-btn action-btn--edit" @click="editarProveedor(data.item)" title="Editar">
                <i class="fa-solid fa-pen"></i>
              </button>
              <button class="action-btn action-btn--delete" @click="borrarProveedor(data.item)" title="Eliminar">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </template>
        </b-table>
      </div>

      <div class="list-card__footer">
        <span class="footer-count">{{ linesTable.length }} proveedores</span>
      </div>
    </div>

    <!-- Modal detalle -->
    <b-modal
      ref="modal-ver-material"
      modal-class="modal-prov"
      centered
      hide-header
      hide-footer
      size="sm"
    >
      <div class="modal-custom">
        <div class="modal-custom__header">
          <div class="modal-custom__icon modal-custom__icon--primary">
            <i class="fa-solid fa-building"></i>
          </div>
          <h4 class="modal-custom__title">{{ itemInfo.nombre }}</h4>
          <p class="modal-custom__subtitle" v-if="itemInfo.nickname">{{ itemInfo.nickname }}</p>
        </div>

        <div class="modal-custom__body">
          <div class="detail-grid">
            <div class="detail-item" v-if="itemInfo.contacto">
              <span class="detail-item__icon"><i class="fa-solid fa-user"></i></span>
              <div>
                <span class="detail-item__label">Contacto</span>
                <span class="detail-item__value">{{ itemInfo.contacto }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.email">
              <span class="detail-item__icon"><i class="fa-solid fa-envelope"></i></span>
              <div>
                <span class="detail-item__label">Email</span>
                <span class="detail-item__value detail-item__value--mono">{{ itemInfo.email }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.telefono">
              <span class="detail-item__icon"><i class="fa-solid fa-phone"></i></span>
              <div>
                <span class="detail-item__label">Telefono</span>
                <span class="detail-item__value detail-item__value--mono">{{ itemInfo.telefono }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.pais">
              <span class="detail-item__icon"><i class="fa-solid fa-globe"></i></span>
              <div>
                <span class="detail-item__label">Pais</span>
                <span class="detail-item__value">{{ itemInfo.pais }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.direccion">
              <span class="detail-item__icon"><i class="fa-solid fa-location-dot"></i></span>
              <div>
                <span class="detail-item__label">Direccion</span>
                <span class="detail-item__value">{{ itemInfo.direccion }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.cif">
              <span class="detail-item__icon"><i class="fa-solid fa-id-card"></i></span>
              <div>
                <span class="detail-item__label">CIF</span>
                <span class="detail-item__value detail-item__value--mono">{{ itemInfo.cif }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.empresa">
              <span class="detail-item__icon"><i class="fa-solid fa-briefcase"></i></span>
              <div>
                <span class="detail-item__label">Empresa</span>
                <span class="detail-item__value">{{ itemInfo.empresa }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.web">
              <span class="detail-item__icon"><i class="fa-solid fa-link"></i></span>
              <div>
                <span class="detail-item__label">Web</span>
                <span class="detail-item__value detail-item__value--mono">{{ itemInfo.web }}</span>
              </div>
            </div>
            <div class="detail-item" v-if="itemInfo.plazo">
              <span class="detail-item__icon"><i class="fa-solid fa-clock"></i></span>
              <div>
                <span class="detail-item__label">Plazo pago</span>
                <span class="detail-item__value">{{ itemInfo.plazo }} dias</span>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-custom__footer">
          <button class="btn-modal btn-modal--ghost" @click="$refs['modal-ver-material'].hide()">Cerrar</button>
          <button class="btn-modal btn-modal--primary" @click="$refs['modal-ver-material'].hide(); editarProveedor(itemInfo)">
            <i class="fa-solid fa-pen"></i> Editar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BCardBody, BCardText, BRow, BCol, BFormGroup, BFormInput, BButton, BTable, BFormCheckbox } from 'bootstrap-vue'
import axios from '@axios'
import vSelect from 'vue-select'

export default {
  components: {
    BCard,
    BCardBody,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BFormCheckbox,
    vSelect
  },
  data(){
    return{
      nombre: "",
      pais: "",
      email: "",
      contacto: "",
      telefono: "",
      nickname: "",
      direccion: "",
      web: "",
      inputPlazo: "",
      empresa: "Harber London",
      colorSelect: "primary",
      buscar: "",
      showForm: false,
      columnasTable: [
        { key: "nombre", label: "Proveedor", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "pais", label: "Pais", sortable: true },
        { key: "empresa", label: "Empresa", sortable: true, thStyle: { width: '90px' } },
        { key: "cif", label: "CIF", sortable: true },
        { key: "acciones", label: "", thStyle: { width: '120px' } },
      ],
      linesTable: [],
      proveedorSelected: null,
      listProveedores: [],
      proveedorSelect: "Todos",
      listadoProveedores: ["Todos","Harber London","Craft Lab"],
      itemInfo: {},
      cif: ''
    }
  },
  computed: {
    countHarber() {
      return this.listProveedores.filter(p => p.empresa === 'Harber London').length
    },
    countCraft() {
      return this.listProveedores.filter(p => p.empresa === 'Craft Lab').length
    },
    countPaises() {
      const paises = new Set()
      this.listProveedores.forEach(p => {
        if (p.pais) paises.add(p.pais.toLowerCase().trim())
      })
      return paises.size
    }
  },
  methods:{
    getColor(color) {
      const colors = {
        primary: '#3B82F6',
        secondary: '#64748B',
        success: '#10B981',
        danger: '#EF4444',
        warning: '#F59E0B',
        info: '#06B6D4'
      }
      return colors[color] || colors.primary
    },
    toggleFormulario() {
      if (this.showForm) {
        this.limpiarFormulario()
      }
      this.showForm = !this.showForm
    },
    load(){
      axios.post("/uso", {seccion:"proveedores"});
      axios
        .get("/proveedores")
        .then(response => {
            return response.data;
        })
        .then(res => {
           res.forEach(proveedor => {
              proveedor.empresaBool = (proveedor.empresa === "Harber London");
          });
          this.listProveedores = res;
          this.linesTable = res;
        });
    },
    guardarProveedor(){
      let info = {
          nombre: this.nombre,
          nickname: this.nickname,
          pais: this.pais,
          email: this.email,
          contacto: this.contacto,
          telefono: this.telefono,
          direccion: this.direccion,
          empresa: this.empresa,
          web: this.web,
          img: null,
          plazo: this.inputPlazo,
          color: this.colorSelect,
          cif: this.cif
      }

      if(this.proveedorSelected == null)
      {
        axios
          .post("/proveedores", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.linesTable.push(info);
            this.limpiarFormulario();
            this.showForm = false;
          });
      }
      else
      {
        info.id = this.proveedorSelected.id;

        axios
          .post("/proveedores/update", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.listProveedores.forEach(prov => {
              if(prov.id == info.id)
              {
                prov.nombre = info.nombre;
                prov.nickname = info.nickname;
                prov.pais = info.pais;
                prov.email = info.email;
                prov.contacto = info.contacto;
                prov.telefono = info.telefono;
                prov.direccion = info.direccion;
                prov.empresa = info.empresa;
                prov.web = info.web;
                prov.plazo = info.plazo;
                prov.color = info.color;
                prov.cif = info.cif;
              }
            });

            this.linesTable.forEach(prov => {
              if(prov.id == info.id)
              {
                prov.nombre = info.nombre;
                prov.nickname = info.nickname;
                prov.pais = info.pais;
                prov.email = info.email;
                prov.contacto = info.contacto;
                prov.telefono = info.telefono;
                prov.direccion = info.direccion;
                prov.empresa = info.empresa;
                prov.web = info.web;
                prov.plazo = info.plazo;
                prov.color = info.color;
                prov.cif = info.cif;
              }
            });

            this.limpiarFormulario();
            this.showForm = false;
          });
      }
    },
    cambiarEmpresa(dato)
    {
       let nombreEmpresa = "Craft Lab";

       if(dato.empresaBool == false)
          nombreEmpresa = "Harber London";

       let info = {
          id: dato.id,
          empresa: nombreEmpresa,
      }

      axios
          .post("/proveedores/update/empresa", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.listProveedores.forEach(prov => {
              if(prov.id == info.id)
              {
                prov.empresa = info.empresa;
                prov.empresaBool = (info.empresa === "Harber London");
              }
            });

            this.linesTable.forEach(prov => {
              if(prov.id == info.id)
              {
                prov.empresa = info.empresa;
                prov.empresaBool = (info.empresa === "Harber London");
              }
            });
          });
    },
    verInformacion(data)
    {
      this.itemInfo = data;
      this.$refs['modal-ver-material'].show();
    },
    editarProveedor(data){
      this.nombre = data.nombre;
      this.nickname = data.nickname;
      this.pais = data.pais;
      this.email = data.email;
      this.contacto = data.contacto;
      this.telefono = data.telefono;
      this.direccion = data.direccion;
      this.empresa = data.empresa;
      this.web = data.web;
      this.inputPlazo = data.plazo;
      this.colorSelect = data.color;
      this.cif = data.cif;

      this.proveedorSelected = data;
      this.showForm = true;

      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    limpiarFormulario(){
      this.nombre = "";
      this.nickname = "";
      this.pais = "";
      this.email = "";
      this.contacto = "";
      this.telefono = "";
      this.direccion = "";
      this.empresa = "Harber London";
      this.web = "";
      this.inputPlazo = "";
      this.cif = "";
      this.colorSelect = "primary"
      this.proveedorSelected = null;
    },
    buscarFuncion(){
      this.linesTable = [];

      this.listProveedores.forEach(prov => {
        if(
          (prov.nombre != null && prov.nombre.toLowerCase().includes(this.buscar.toLowerCase())) ||
          (prov.nickname != null && prov.nickname.toLowerCase().includes(this.buscar.toLowerCase())) ||
          (prov.email != null && prov.email.toLowerCase().includes(this.buscar.toLowerCase())) ||
          (prov.contacto != null && prov.contacto.toLowerCase().includes(this.buscar.toLowerCase())) ||
          (prov.telefono != null && prov.telefono.toLowerCase().includes(this.buscar.toLowerCase())) ||
          (prov.cif != null && prov.cif.toLowerCase().includes(this.buscar.toLowerCase())) ||
          (prov.web != null && prov.web.toLowerCase().includes(this.buscar.toLowerCase()))
          )
          {
            if(this.proveedorSelect == "Todos")
              this.linesTable.push(prov);
            else if(prov.empresa == this.proveedorSelect)
              this.linesTable.push(prov);
          }
      });
    },
    borrarProveedor(item) {
      this.$swal.fire({
        title: 'Eliminar proveedor',
        text: `Se eliminara "${item.nickname || item.nombre}".`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        customClass: {
              cancelButton: 'btn btn-primary ml-1',
              confirmButton: 'btn btn-outline-danger eliminar-btn',
          },
      }).then((result) => {
        if (result.isConfirmed) {
            axios
              .post("/proveedores/delete", item )
              .then(response => {
                  return response.data;
              })
              .then(res => {
                  this.listProveedores = this.listProveedores.filter(p => p.id !== item.id);
                  this.linesTable = this.linesTable.filter(p => p.id !== item.id);

                  this.$swal.fire(
                    'Eliminado',
                    `El proveedor "${item.nickname || item.nombre}" fue eliminado.`,
                    'success'
                  );
              });
        }
      });
    }
  },
  mounted() {
    this.load();
  },
  watch: {
      buscar(){
        this.buscarFuncion();
      },
      proveedorSelect(){
        this.buscarFuncion();
      },
  }
}
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$primary-dark: #2563EB;
$success: #10B981;
$danger: #EF4444;
$warning: #F59E0B;
$info: #06B6D4;
$border: #E2E8F0;
$text: #1E293B;
$text-muted: #64748B;
$bg: #F8FAFC;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);

.proveedores-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 8px;
}

// Header
.prov-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
}

.header-eyebrow {
  display: block;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: $primary;
  margin-bottom: 2px;
}

.header-title {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: $text;
  margin: 0;
}

// KPI Strip
.kpi-strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.kpi-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius-sm;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  box-shadow: $shadow;
}

.kpi-label {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
}

.kpi-value {
  font-family: 'JetBrains Mono', monospace;
  font-size: 22px;
  font-weight: 700;
  color: $text;
  font-feature-settings: "tnum";
  margin: 4px 0 2px;
}

.kpi-foot {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: $text-muted;
}

// Buttons
.btn-prov {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 20px;
  border-radius: $radius-sm;
  border: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &--primary {
    background: $primary;
    color: white;
    &:hover { background: $primary-dark; }
  }

  &--warning {
    background: $warning;
    color: white;
    &:hover { background: darken($warning, 8%); }
  }

  &--ghost {
    background: transparent;
    color: $text-muted;
    &:hover { background: $bg; color: $text; }
  }
}

// Form Card
.form-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius;
  box-shadow: $shadow;
  margin-bottom: 20px;
  overflow: hidden;

  &__header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 22px 24px 0;
  }

  &__icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;

    &--primary { background: rgba($primary, 0.1); color: $primary; }
    &--warning { background: rgba($warning, 0.1); color: $warning; }
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: $text;
    margin: 0;
  }

  &__subtitle {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: $text-muted;
    margin: 2px 0 0;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 0 24px 20px;
  }
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  padding: 20px 24px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 5px;

  &--span2 { grid-column: span 2; }

  &__label {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: $text-muted;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__input {
    border-radius: 8px !important;
    border: 1px solid $border !important;
    font-size: 13px !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:focus {
      border-color: $primary !important;
      box-shadow: 0 0 0 3px rgba($primary, 0.1) !important;
    }
  }
}

.badge-color {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;

  &--primary { background: $primary; }
  &--secondary { background: #64748B; }
  &--success { background: $success; }
  &--danger { background: $danger; }
  &--warning { background: $warning; }
  &--info { background: $info; }
}

// Slide transition
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
  max-height: 600px;
  overflow: hidden;
}
.slide-enter, .slide-leave-to {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0;
}

// List Card
.list-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius;
  box-shadow: $shadow;
  overflow: hidden;

  &__header {
    padding: 20px 22px;
    border-bottom: 1px solid $border;
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: $text;
    margin: 0 0 14px;
  }

  &__filters {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
  }

  &__footer {
    padding: 12px 22px;
    border-top: 1px solid $border;
  }
}

.filter-pills {
  display: flex;
  gap: 6px;
}

.pill {
  padding: 5px 14px;
  border-radius: 20px;
  border: 1px solid $border;
  background: transparent;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 500;
  color: $text-muted;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: $primary;
    color: $primary;
  }

  &.active {
    background: $primary;
    border-color: $primary;
    color: white;
  }
}

.search-box {
  position: relative;
  width: 240px;

  &__icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: $text-muted;
    font-size: 12px;
  }

  &__input {
    width: 100%;
    padding: 7px 12px 7px 32px;
    border: 1px solid $border;
    border-radius: $radius-sm;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    color: $text;
    background: transparent;
    transition: border-color 0.15s ease;

    &::placeholder { color: #CBD5E1; }
    &:focus { outline: none; border-color: $primary; }
  }
}

// Table
.table-wrapper {
  padding: 0;
}

// Los ::v-deep van bajo .proveedores-page a proposito: en la raiz, postcss-rtl + scoped generan [dir][data-v-xxx]
// y ninguna propiedad direccional (padding, margin...) llega a aplicarse.
.proveedores-page ::v-deep .table-head th {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
  border-top: none;
  border-bottom: 1px solid $border;
  padding: 10px 16px;
  background: transparent;
}

.proveedores-page ::v-deep .table-row td {
  padding: 12px 16px;
  vertical-align: middle;
  border-color: lighten($border, 3%);
  font-size: 13px;
}

.proveedores-page ::v-deep .table-row:hover td {
  background: $bg;
}

.cell-nombre {
  display: flex;
  align-items: center;
  gap: 10px;

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__name {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    color: $text;
    display: block;
    line-height: 1.2;
  }

  &__nick {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: $text-muted;
  }
}

.cell-mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: $text;
}

.cell-pais {
  font-size: 13px;
  color: $text;
}

.cell-muted {
  color: #CBD5E1;
  font-size: 12px;
}

.badge-empresa {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;

  &--hb {
    background: rgba($primary, 0.1);
    color: $primary;
  }

  &--cl {
    background: rgba($success, 0.1);
    color: $success;
  }
}

.cell-actions {
  display: flex;
  gap: 4px;
}

.action-btn {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: $text-muted;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  font-size: 12px;

  &--view:hover {
    background: rgba($info, 0.1);
    color: $info;
    border-color: rgba($info, 0.2);
  }

  &--edit:hover {
    background: rgba($primary, 0.1);
    color: $primary;
    border-color: rgba($primary, 0.2);
  }

  &--delete:hover {
    background: rgba($danger, 0.1);
    color: $danger;
    border-color: rgba($danger, 0.2);
  }
}

.footer-count {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: $text-muted;
}

// Responsive
@media (max-width: 768px) {
  .kpi-strip { grid-template-columns: repeat(2, 1fr); }
  .form-grid { grid-template-columns: 1fr 1fr; }
  .field--span2 { grid-column: span 2; }
  .prov-header { flex-direction: column; align-items: flex-start; gap: 12px; }
  .list-card__filters { flex-direction: column; align-items: flex-start; }
  .search-box { width: 100%; }
}

@media (max-width: 480px) {
  .form-grid { grid-template-columns: 1fr; }
  .field--span2 { grid-column: span 1; }
}
</style>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';

// Vue-select styled (unscoped)
.proveedores-page {
  .select-styled {
    .vs__dropdown-toggle {
      min-height: 31px;
      padding: 0 0 2px 0;
      border-radius: 8px;
      border: 1px solid #E2E8F0;
      transition: border-color 0.15s ease;
    }

    .vs__search {
      font-size: 13px;
      font-family: 'Plus Jakarta Sans', sans-serif;
    }

    &.vs--open .vs__dropdown-toggle {
      border-color: #3B82F6;
      box-shadow: 0 0 0 3px rgba(#3B82F6, 0.1);
    }
  }
}

.eliminar-btn {
  color: white !important;
}

// Modal styles
.modal-prov {
  .modal-content {
    border-radius: 16px;
    border: 1px solid #E2E8F0;
    box-shadow: 0 20px 60px rgba(0,0,0,0.12), 0 8px 20px rgba(0,0,0,0.06);
    overflow: hidden;
  }

  .modal-body {
    padding: 0;
  }
}

.modal-custom {
  &__header {
    text-align: center;
    padding: 28px 28px 0;
  }

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    font-size: 18px;

    &--primary { background: rgba(#3B82F6, 0.1); color: #3B82F6; }
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #1E293B;
    margin: 0 0 4px;
  }

  &__subtitle {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: #64748B;
    margin: 0;
  }

  &__body {
    padding: 22px 28px;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 0 28px 24px;
  }
}

.detail-grid {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  transition: background 0.1s ease;

  &:hover { background: #F8FAFC; }

  &__icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    background: #F1F5F9;
    color: #64748B;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    flex-shrink: 0;
    margin-top: 1px;
  }

  &__label {
    display: block;
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #94A3B8;
    line-height: 1;
    margin-bottom: 3px;
  }

  &__value {
    display: block;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #1E293B;
    line-height: 1.3;
    word-break: break-all;

    &--mono {
      font-family: 'JetBrains Mono', monospace;
      font-size: 13px;
      font-feature-settings: "tnum";
    }
  }
}

.btn-modal {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: 8px;
  border: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &--primary {
    background: #3B82F6;
    color: white;
    &:hover { background: #2563EB; }
  }

  &--ghost {
    background: transparent;
    color: #64748B;
    &:hover { background: #F1F5F9; color: #1E293B; }
  }
}

// Dark mode
.dark-layout {
  .proveedores-page {
    .header-title { color: #E2E8F0; }

    .kpi-card { background: #1E293B; border-color: #334155; }
    .kpi-value { color: #F1F5F9; }

    .form-card { background: #1E293B; border-color: #334155; }
    .form-card__title { color: #E2E8F0; }

    .field__label { color: #94A3B8; }
    .field__input {
      background: #0F172A !important;
      border-color: #334155 !important;
      color: #E2E8F0 !important;
      &:focus { border-color: #3B82F6 !important; }
    }

    .list-card { background: #1E293B; border-color: #334155; }
    .list-card__header { border-color: #334155; }
    .list-card__title { color: #E2E8F0; }
    .list-card__footer { border-color: #334155; }

    .pill {
      border-color: #475569;
      color: #94A3B8;
      &:hover { border-color: #3B82F6; color: #3B82F6; }
      &.active { background: #3B82F6; border-color: #3B82F6; color: white; }
    }

    .search-box__input {
      border-color: #334155;
      color: #E2E8F0;
      &::placeholder { color: #475569; }
      &:focus { border-color: #3B82F6; }
    }

    .table-head th { color: #94A3B8; border-color: #334155; }
    .table-row td { border-color: #334155; }
    .table-row:hover td { background: rgba(255,255,255,0.03); }

    .cell-nombre__name { color: #E2E8F0; }
    .cell-mono { color: #E2E8F0; }
    .cell-pais { color: #E2E8F0; }

    .action-btn { color: #94A3B8; }

    .select-styled {
      .vs__dropdown-toggle { border-color: #334155; background: #0F172A; }
      .vs__search { color: #E2E8F0; }
    }
  }

  .modal-prov .modal-content { background: #1E293B; border-color: #334155; }
  .modal-custom__title { color: #E2E8F0; }
  .detail-item:hover { background: rgba(255,255,255,0.03); }
  .detail-item__icon { background: #334155; color: #94A3B8; }
  .detail-item__value { color: #E2E8F0; }
}
</style>
